import { render, staticRenderFns } from "./AdminRequests.vue?vue&type=template&id=3ee74f54&scoped=true&"
import script from "./AdminRequests.vue?vue&type=script&lang=js&"
export * from "./AdminRequests.vue?vue&type=script&lang=js&"
import style0 from "./AdminRequests.vue?vue&type=style&index=0&id=3ee74f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee74f54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCheckbox,VPagination,VSnackbar})
